import styled from "styled-components";

export const EmployeeDetailsSc = styled.div`
  /* width: 100vw; */
  width: 100vw;
  position: absolute;
  top: 50px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  margin: 10px;
  .downloadModal {
    align-self: flex-end;
  }
  table {
    border-collapse: collapse;
    width: 90vw;
  }
  .table-details {
    width: 90vw;
  }
  th {
    background-color: #4285f4;
    border: 1px solid #4285f4;
    color: #fff;
    padding: 8px;
    text-align: left;
    font-weight: bold;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-width: 5px;
    border: 1px solid black;
  }
  td {
    text-align: left;
    border: 1px solid black;
  }

  /* th:first-child {
    width: 200px;
  } */
`;
